module.exports = __webpack_public_path__ + "static/media/itakeoff.6f9159c5.svg";